//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "lucky",
    data() {
        return {
            lang: '',
            num1: ['9065 XXX9'],
            num2: [
                '5345 XXX4',
                '9715 XXX3',
                '5932 XXX3',
            ],
            num3: {
                left: [
                    '6093 XXX2',
                    '5629 XXX3',
                    '5125 XXX6'
                ],
                right: [
                    '5102 XXX6',
                    '6672 XXX5',
                    '5619 XXX7'
                ]
            },
            num4: {
                left: '',
                right: ''
            },
            num5: {
                left: '',
                center: '',
                right: ''
            }
        }
    },
    created() {
        let num4Left = '5373 XXX0\n' +
            '6642 XXX2\n' +
            '5645 XXX3\n' +
            '6570 XXX2\n' +
            '9431 XXX2\n' +
            '5483 XXX1\n' +
            '5641 XXX4\n' +
            '5138 XXX0\n' +
            '5625 XXX5\n' +
            '5427 XXX3\n' +
            '6749 XXX8\n' +
            '5378 XXX0\n' +
            '5426 XXX8\n' +
            '5982 XXX7\n' +
            '6238 XXX3\n' +
            '5372 XXX3\n' +
            '5347 XXX4\n' +
            '5340 XXX5\n' +
            '5319 XXX2\n' +
            '5136 XXX6\n' +
            '5482 XXX4\n' +
            '6099 XXX2\n' +
            '5125 XXX4\n' +
            '9340 XXX1\n' +
            '6746 XXX0'
        let num4Right = '9713 XXX4\n' +
            '5647 XXX3\n' +
            '6734 XXX2\n' +
            '5101 XXX4\n' +
            '9080 XXX1\n' +
            '6707 XXX9\n' +
            '5341 XXX1\n' +
            '6484 XXX7\n' +
            '5571 XXX0\n' +
            '6354 XXX9\n' +
            '6843 XXX3\n' +
            '6764 XXX2\n' +
            '5175 XXX1\n' +
            '5617 XXX3\n' +
            '6226 XXX1\n' +
            '5601 XXX2\n' +
            '6937 XXX4\n' +
            '5160 XXX3\n' +
            '5265 XXX3\n' +
            '9713 XXX5\n' +
            '9581 XXX4\n' +
            '5127 XXX2\n' +
            '5494 XXX2\n' +
            '5174 XXX3\n' +
            '9075 XXX3'
        let num5Left = '5393 XXX9\n' +
            '5985 XXX5\n' +
            '6768 XXX5\n' +
            '5424 XXX5\n' +
            '5624 XXX3\n' +
            '5269 XXX7\n' +
            '6840 XXX7\n' +
            '5649 XXX7\n' +
            '5103 XXX4\n' +
            '5483 XXX7\n' +
            '6841 XXX2\n' +
            '6764 XXX3\n' +
            '5441 XXX7\n' +
            '6598 XXX5\n' +
            '6486 XXX3\n' +
            '5573 XXX3\n' +
            '5618 XXX0\n' +
            '5301 XXX3\n' +
            '6641 XXX8\n' +
            '5481 XXX2\n' +
            '5262 XXX2\n' +
            '5130 XXX7\n' +
            '6674 XXX6\n' +
            '5315 XXX2\n' +
            '6476 XXX1\n' +
            '5129 XXX2\n' +
            '9797 XXX4\n' +
            '6736 XXX2\n' +
            '5227 XXX6\n' +
            '5308 XXX1\n' +
            '5316 XXX7\n' +
            '5624 XXX2\n' +
            '5425 XXX5\n' +
            '6844 XXX3\n' +
            '5513 XXX4\n' +
            '5627 XXX6\n' +
            '6487 XXX2\n' +
            '5604 XXX9\n' +
            '5137 XXX4\n' +
            '5939 XXX3\n' +
            '6572 XXX0\n' +
            '6848 XXX8\n' +
            '6743 XXX9\n' +
            '5937 XXX9\n' +
            '5645 XXX6\n' +
            '5531 XXX2\n' +
            '5515 XXX2\n' +
            '5481 XXX8\n' +
            '5488 XXX6\n' +
            '6439 XXX8\n' +
            '5937 XXX4\n' +
            '5603 XXX6\n' +
            '5166 XXX0\n' +
            '5425 XXX5\n' +
            '9710 XXX1\n' +
            '5343 XXX1\n' +
            '5269 XXX9\n' +
            '5160 XXX6\n' +
            '6850 XXX8\n' +
            '6844 XXX4\n' +
            '5612 XXX4\n' +
            '6641 XXX2\n' +
            '6747 XXX2\n' +
            '5486 XXX7\n' +
            '5571 XXX3\n' +
            '6749 XXX4\n' +
            '6231 XXX5'
        let num5Center = '5616 XXX5\n' +
            '5647 XXX0\n' +
            '6761 XXX4\n' +
            '9582 XXX4\n' +
            '6742 XXX6\n' +
            '6642 XXX3\n' +
            '6857 XXX2\n' +
            '5615 XXX2\n' +
            '5344 XXX5\n' +
            '5425 XXX9\n' +
            '6874 XXX5\n' +
            '6749 XXX1\n' +
            '9582 XXX2\n' +
            '5301 XXX8\n' +
            '5448 XXX5\n' +
            '5480 XXX6\n' +
            '6762 XXX2\n' +
            '5109 XXX1\n' +
            '5645 XXX1\n' +
            '9149 XXX5\n' +
            '6737 XXX8\n' +
            '5495 XXX9\n' +
            '5643 XXX6\n' +
            '6572 XXX2\n' +
            '5608 XXX5\n' +
            '6158 XXX0\n' +
            '5449 XXX7\n' +
            '5482 XXX4\n' +
            '6154 XXX9\n' +
            '6705 XXX1\n' +
            '5139 XXX0\n' +
            '5128 XXX3\n' +
            '6855 XXX5\n' +
            '6935 XXX0\n' +
            '5378 XXX0\n' +
            '5164 XXX9\n' +
            '9511 XXX2\n' +
            '5486 XXX7\n' +
            '5629 XXX4\n' +
            '9609 XXX7\n' +
            '6749 XXX2\n' +
            '5614 XXX1\n' +
            '9475 XXX5\n' +
            '9276 XXX0\n' +
            '6578 XXX3\n' +
            '5269 XXX3\n' +
            '9063 XXX6\n' +
            '6092 XXX3\n' +
            '5446 XXX3\n' +
            '6239 XXX0\n' +
            '9766 XXX9\n' +
            '6579 XXX2\n' +
            '6436 XXX2\n' +
            '9408 XXX3\n' +
            '5616 XXX1\n' +
            '5164 XXX2\n' +
            '5308 XXX4\n' +
            '5428 XXX3\n' +
            '5106 XXX6\n' +
            '9607 XXX2\n' +
            '6741 XXX6\n' +
            '9025 XXX6\n' +
            '6230 XXX3\n' +
            '6991 XXX3\n' +
            '5424 XXX2\n' +
            '5427 XXX6\n' +
            '5604 XXX4'
        let num5Right = '5175 XXX4\n' +
            '5129 XXX6\n' +
            '6733 XXX0\n' +
            ' 5486 XXX8\n' +
            '6937 XXX3\n' +
            '5486 XXX7\n' +
            '5421 XXX0\n' +
            '5133 XXX7\n' +
            '6732 XXX2\n' +
            '5980 XXX4\n' +
            '6574 XXX4\n' +
            '5374 XXX5\n' +
            '6874 XXX6\n' +
            '5494 XXX8\n' +
            '6849 XXX0\n' +
            '5262 XXX4\n' +
            '5601 XXX3\n' +
            '6746 XXX6\n' +
            '6851 XXX2\n' +
            '6581 XXX5\n' +
            '5131 XXX4\n' +
            '5135 XXX4\n' +
            '9060 XXX1\n' +
            '9370 XXX1\n' +
            '6353 XXX3\n' +
            '5532 XXX1\n' +
            '5308 XXX0\n' +
            '5627 XXX9\n' +
            '5486 XXX4\n' +
            '6313 XXX2\n' +
            '5534 XXX9\n' +
            '5372 XXX5\n' +
            '6840 XXX1\n' +
            '5443 XXX4\n' +
            '6430 XXX3\n' +
            '6572 XXX9\n' +
            '5316 XXX4\n' +
            '5515 XXX0\n' +
            '6082 XXX9\n' +
            '6701 XXX6\n' +
            '9140 XXX0\n' +
            '5937 XXX4\n' +
            '6622 XXX4\n' +
            '6676 XXX7\n' +
            '6939 XXX1\n' +
            '6223 XXX4\n' +
            '5498 XXX6\n' +
            '9141 XXX3\n' +
            '6231 XXX0\n' +
            '5443 XXX6\n' +
            '5613 XXX5\n' +
            '5486 XXX8\n' +
            '9802 XXX2\n' +
            '5349 XXX0\n' +
            '5644 XXX5\n' +
            '5619 XXX1\n' +
            '5427 XXX3\n' +
            '6115 XXX9\n' +
            '6180 XXX7\n' +
            '5576 XXX2\n' +
            '6647 XXX5\n' +
            '5261 XXX2\n' +
            '5344 XXX3\n' +
            '6575 XXX4\n' +
            '9144 XXX6\n' +
            '5648 XXX8'
        this.num4.left = num4Left.split(/\n/)
        this.num4.right = num4Right.split(/\n/)
        this.num5.left = num5Left.split(/\n/)
        this.num5.center = num5Center.split(/\n/)
        this.num5.right = num5Right.split(/\n/)
        this.lang = window.localStorage.lang
    }
}



// WEBPACK FOOTER //
// ./src/page/lucky.vue